<template>
  <div style="width: 100%;height: 100%;">
    <div id="map" style="width: 100%;height: 100%;"></div>
  </div>
</template>
<script>

  export default {
    name: "BDMap",
    props:{
      lng:{
        type: String,
        required: true
      },
      lat:{
        type: String,
        required: true
      },
    },
    data() {
      return {
        map:''
      }

    },
    methods:{

    },
    mounted() {
      this.map = new BMap.Map('map');
      console.log("map="+this.map);
      let point = new BMap.Point(this.lng,this.lat);// 创建点坐标
      this.map.centerAndZoom(point, 18);// 初始化地图，设置中心点坐标和地图级别
      this.map.enableScrollWheelZoom();//启用滚轮放大缩小，默认禁用。
      var myicon = new BMap.Icon("/static/img/icon/maker2.png", new BMap.Size(18, 31), {
        // 图标中央下端的尖角位置。
        anchor: new BMap.Size(9, 31),
      });
      var marker = new BMap.Marker(point, {icon: myicon});
      this.map.addOverlay(marker);
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/05Management/BDMap.vue